import { API_BASE_URL } from "@/libs/constants/apis";
import { fetchUtil } from "@/libs/fetch";

export const fetchVideosAPI: (slug: string) => Promise<any> = async (slug) => {
  return await fetchUtil({
    url: `${API_BASE_URL}/api/videos/filterVideos`,
    method: "POST",
    body: {
      CategorySlug: [slug],
      PillarSlug: null,
    },
    useToken: false,
  });
};
